import {
  Box,
  Flex,
  Grid,
  Input,
  InputGroup,
  InputLeftAddon
} from '@chakra-ui/react'
import dayjs from 'dayjs'
import { FC, useCallback, useMemo, useState } from 'react'
import ReactApexChart from 'react-apexcharts'

import LayoutEmpty from '@component/Layout/Empty'

import { IDefaultDate } from '@base/@types/providers/Kpi/SalesProvider'

import {
  getStorageSeries,
  storageOptions
} from './ParseInfos/parseStorageChartInfos'

interface IKpiStorageGraphicProps {
  data: any[]
  daysQuantity: number
}
export const updateGraphicDataDefault = (data: any[]) => {
  const dateNow = new Date()
  const dateEnd = dateNow.setDate(dateNow.getDate() - 7)
  const initialDate = dayjs(dateEnd).format('YYYY-MM-DD')
  const finalDate = dayjs(new Date()).format('YYYY-MM-DD')
  const initialDateUpdated = initialDate
  const finalDateUpdated = finalDate

  const newEstoqueReaisAtual = data?.filter(item => {
    const itemDate = dayjs(item.data).format('YYYY-MM-DD')
    return (
      new Date(itemDate) >= new Date(initialDateUpdated) &&
      new Date(itemDate) <= new Date(finalDateUpdated)
    )
  })
  // const newStorageDOH = newData.estoqueDOH.filter(item => {
  //   const itemDate = dayjs(item.data).format('YYYY-MM-DD')

  //   return (
  //     new Date(itemDate) >= new Date(initialDateUpdated) &&
  //     new Date(itemDate) <= new Date(finalDateUpdated)
  //   )
  // })

  // const newRuptura = newData.ruptura.filter(item => {
  //   const itemDate = dayjs(item.data).format('YYYY-MM-DD')

  //   return (
  //     new Date(itemDate) >= new Date(initialDateUpdated) &&
  //     new Date(itemDate) <= new Date(finalDateUpdated)
  //   )
  // })

  // const newGmroi = newData.gmroi.filter(item => {
  //   const itemDate = dayjs(item.data).format('YYYY-MM-DD')

  //   return (
  //     new Date(itemDate) >= new Date(initialDateUpdated) &&
  //     new Date(itemDate) <= new Date(finalDateUpdated)
  //   )
  // })

  return newEstoqueReaisAtual
}

const KpiStorageGraphic: FC<IKpiStorageGraphicProps> = ({ data }) => {
  const [graphicData, setGraphicData] = useState<any[]>(
    updateGraphicDataDefault(data)
  )
  const [initialDate, setInitialDate] = useState('')
  const [finalDate, setFinalDate] = useState('')

  const defaultDate = useMemo(() => {
    const dateNow = new Date()
    const dateEnd = dateNow.setDate(dateNow.getDate() - 7)
    const initialDate = dayjs(dateEnd).format('YYYY-MM-DD')
    const finalDate = dayjs(new Date()).format('YYYY-MM-DD')

    setInitialDate(initialDate)
    setFinalDate(finalDate)

    return {
      initialDate,
      finalDate
    } as IDefaultDate
  }, [])

  const updateGraphicData = useCallback(
    (value: string, name: string) => {
      const initialDateUpdated = name === 'initial' ? value : initialDate
      const finalDateUpdated = name === 'final' ? value : finalDate

      const newEstoqueReaisAtual = data?.filter(item => {
        const itemDate = dayjs(item.data).format('YYYY-MM-DD')
        return (
          new Date(itemDate) >= new Date(initialDateUpdated) &&
          new Date(itemDate) <= new Date(finalDateUpdated)
        )
      })
      // const newStorageDOH = newData.estoqueDOH.filter(item => {
      //   const itemDate = dayjs(item.data).format('YYYY-MM-DD')

      //   return (
      //     new Date(itemDate) >= new Date(initialDateUpdated) &&
      //     new Date(itemDate) <= new Date(finalDateUpdated)
      //   )
      // })

      // const newRuptura = newData.ruptura.filter(item => {
      //   const itemDate = dayjs(item.data).format('YYYY-MM-DD')

      //   return (
      //     new Date(itemDate) >= new Date(initialDateUpdated) &&
      //     new Date(itemDate) <= new Date(finalDateUpdated)
      //   )
      // })

      // const newGmroi = newData.gmroi.filter(item => {
      //   const itemDate = dayjs(item.data).format('YYYY-MM-DD')

      //   return (
      //     new Date(itemDate) >= new Date(initialDateUpdated) &&
      //     new Date(itemDate) <= new Date(finalDateUpdated)
      //   )
      // })

      setInitialDate(initialDateUpdated)
      setFinalDate(finalDateUpdated)

      setGraphicData(newEstoqueReaisAtual)
    },
    [data, finalDate, initialDate]
  )

  return (
    <Box borderTop="1px solid #e3e3e3">
      <Grid background="gray.100" paddingTop={4}>
        {/* <Center>
          <LegendItem color="#1d5840" label="Estq Empresa R$" />
          <LegendItem color="#ecc94b" label="CMV R$" />
          <LegendItem color="#8e9aaf" label="Estq Empresa Dias" />
        </Center> */}
        <Flex marginLeft={9} marginBottom={2}>
          <InputGroup width="155px" marginRight={4}>
            <InputLeftAddon
              width={8}
              height={6}
              justifyContent="center"
              children="De:"
              fontSize={12}
              fontWeight={600}
              background="gray.100"
              borderColor="gray.300"
            />
            <Input
              type="date"
              background="gray.50"
              fontSize={12}
              fontWeight={600}
              height={6}
              paddingLeft={1}
              paddingRight={0.5}
              borderColor="gray.300"
              defaultValue={defaultDate.initialDate}
              _hover={{
                border: 'gray.300'
              }}
              onChange={({ target }) =>
                updateGraphicData(target.value, 'initial')
              }
            />
          </InputGroup>

          <InputGroup width="155px">
            <InputLeftAddon
              width={8}
              height={6}
              justifyContent="center"
              children="Até:"
              fontSize={12}
              fontWeight={600}
              background="gray.100"
              borderColor="gray.300"
            />
            <Input
              type="date"
              background="gray.50"
              fontSize={12}
              fontWeight={600}
              height={6}
              paddingLeft={1}
              paddingRight={0.5}
              borderColor="gray.300"
              defaultValue={defaultDate.finalDate}
              _hover={{
                border: 'gray.300'
              }}
              onChange={({ target }) =>
                updateGraphicData(target.value, 'final')
              }
            />
          </InputGroup>
        </Flex>

        {graphicData.length === 0 ? (
          <Box height={290}>
            <LayoutEmpty
              type="chartEmpty"
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          </Box>
        ) : (
          <>
            <Box paddingLeft={6}>
              <ReactApexChart
                options={storageOptions(graphicData) as any}
                series={getStorageSeries(graphicData)}
                width="100%"
                height="205px"
              />
            </Box>

            {/* <Box paddingLeft={6} paddingRight={4} marginTop={-55}>
              <ReactApexChart
                options={storageOptionsLine(graphicData)}
                series={getStorageSeries(graphicData)}
                width="100%"
                height="110px"
              />
            </Box> */}
          </>
        )}
      </Grid>
    </Box>
  )
}

export default KpiStorageGraphic
